import React from "react";

const MidBanner = () => {
    return (
        <div className="banner_title" style={{display: "block !important"}}>
            <div>
                <div className="MsoNormal" style={{textAlign: "center", marginTop: "12px"}}>
                    <strong>CHUY&Ecirc;N TRANG KẾT QUẢ XỔ SỐ KIẾN THIẾT</strong></div>
                <div className="MsoNormal" style={{textAlign: "center"}}>
                                <span
                                    style={{
                                        fontSize: "28px",
                                        fontFamily: "times new roman, times, serif",
                                        color: "rgb(178, 34, 34)"
                                    }}>
                                    <strong>MINH NGỌC</strong><br/>
                                </span>
                </div>
            </div>
        </div>
    )
};
export default MidBanner;
